import {useEffect, useRef, useState} from 'react';
import {Link} from "react-router-dom";
import {UseDelete, UsePut} from "../../hooks/http";
import {UseLimit, UseOrder} from "../../hooks/settings";
import {UseMessage} from "../../hooks/UseMessage";

import ListingTable from "../../components/listing/listing";
import {GetDateTimeLocal, UtcDateTimeToDateTime} from "../../hooks/dates";
import Select from "../../components/input/select";
import {Col, Row} from "react-bootstrap";

import Button from "../../components/button";
import UseGetFormData from "../../hooks/UseGetFormData";


const Filters = (props) => {
    const FormRef = useRef()
    const {isReady, onApplyFilter} = props
    const [accounts, setAccounts] = useState([])
    const [enterprises, setEnterprises] = useState([])
    const [audiences, setAudiences] = useState([])
    const [journeys, setJourneys] = useState([])

    const [selectedAccount, setSelectedAccount] = useState()
    const [selectedEnterprise, setSelectedEnterprise] = useState()
    const [selectedAudience, setSelectedAudience] = useState()
    const [selectedJourney, setSelectedJourney] = useState()
    const [selectedCreativity, setSelectedCreativity] = useState()
    const [selectedChannel, setSelectedChannel] = useState()
    const [selectedType, setSelectedType] = useState()


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(FormRef)
        const data = {
            start_date: FormData.get('start_date'),
            end_date  : FormData.get('end_date'),
        }


        if (selectedAccount?.length > 0) {
            data['id_account'] = selectedAccount
        }

        if (selectedEnterprise?.length > 0) {
            data['id_enterprise'] = selectedEnterprise
        }

        if (selectedAudience?.length > 0) {
            data['id_audience'] = selectedAudience
        }

        if (selectedJourney?.length > 0) {
            data['id_journey'] = selectedJourney
        }

        if (selectedCreativity?.length > 0) {
            data['id_creativity'] = selectedCreativity
        }

        if (selectedChannel?.length > 0) {
            data['channel'] = selectedChannel
        }

        if (selectedType?.length > 0) {
            data['type'] = selectedType
        }

        onApplyFilter(data)
    }


    const GetAccounts = async () => {
        return await UsePut(
            '/accounts/get',
            {toArray: true, propsValue: '_id', propLabel: 'name'}
        )
    }


    const handleAccount = async (selected) => {
        setSelectedAccount(selected.value)

        const enterprises = await UsePut('/enterprises/get', {
            data   : {id_account: selected.value},
            toArray: true, propLabel: 'name'
        })

        const journeys = await UsePut('/journeys/get', {
            toArray: true, propLabel: 'title'
        })

        const audiences = await UsePut('/audiences/get', {
            toArray: true, propLabel: 'name'
        })

        setEnterprises(enterprises)
        setAudiences(audiences)
        setJourneys(journeys)
    }



    const handleEnterprise = async (selected) => {
        setSelectedEnterprise(selected.value)
        const audiences = await UsePut('/audiences/get', {
            data   : {id_enterprise: selected.value},
            toArray: true, propLabel: 'name'
        })
        setAudiences(audiences)
    }



    const handleAudience = async (selected) => {
        setSelectedAudience(selected.value)
        const journeys = await UsePut('/journeys/get', {
            data   : {id_audience: selected.value},
            toArray: true, propLabel: 'title'
        })
        setJourneys(journeys)
    }

    const handleJourney = (selected) => {
        setSelectedJourney(selected.value)
    }

    const handleCreativity = (selected) => {
        setSelectedCreativity(selected.value)
    }

    const handleChannel = (selected) => {
        setSelectedChannel(selected.value)
    }

    const handleType = (selected) => {
        setSelectedType(selected.value)
    }


    useEffect(() => {
        GetAccounts().then((response) => {
            setAccounts(response)
        })
    }, [])


    return (<div className="filters-lg">
        <form ref={FormRef} onSubmit={handleSubmit}>
            <Row>
                <Col sm={4}>
                    <Select
                        size="xs"
                        name="id_account"
                        isReady={isReady}
                        options={accounts}
                        placeholder="Choose Account"
                        onChange={handleAccount}
                    />
                </Col>
                <Col sm={4}>
                    <Select
                        size="xs"
                        isReady={isReady}
                        options={enterprises}
                        name="id_enterprise"
                        placeholder="Choose Enterprise"
                        onChange={handleEnterprise}
                    />
                </Col>
                <Col sm={4}>
                    <Select
                        size="xs"
                        isReady={isReady}
                        name="id_audience"
                        options={audiences}
                        placeholder="Choose Audience"
                        onChange={handleAudience}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={4}>
                    <Select
                        size="xs"
                        name="id_journey"
                        isReady={isReady}
                        options={journeys}
                        placeholder="Choose Journey"
                        onChange={handleJourney}
                    />
                </Col>
                <Col sm={4}>
                    <Select
                        size="xs"
                        isReady={isReady}
                        name="id_creativity"
                        placeholder="Choose Creativity"
                        onChange={handleCreativity}
                    />
                </Col>
                <Col sm={4}>
                    <Select
                        size="xs"
                        name="channel"
                        isReady={isReady}
                        placeholder="Choose Channel"
                        onChange={handleChannel}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={4}>
                    <div className="form-group">
                        <Select
                            size="xs"
                            name="type"
                            isReady={isReady}
                            placeholder="Choose Type"
                            options={[
                                {value: 'runtime', label: "Runtimes"},
                                {value: 'user_log', label: "User Logs Only"},
                                {value: 'error', label: "Errors Only"},
                                {value: 'generic', label: "Generics Only"},
                            ]}
                            onChange={handleType}
                        />
                    </div>
                </Col>
                <Col sm={4}>
                    <div className="form-group">
                        <input
                            name="start_date"
                            type="datetime-local"
                            disabled={!isReady}
                            placeholder="Start Date"
                            className="form-control form-control-xs"
                            defaultValue={GetDateTimeLocal(new Date(new Date() - 14 * 24 * 60 * 60 * 1000))}
                        />
                    </div>
                </Col>
                <Col sm={4}>
                    <div className="form-group">
                        <input
                            name="end_date"
                            type="datetime-local"
                            disabled={!isReady}
                            placeholder="Start Date"
                            defaultValue={GetDateTimeLocal()}
                            max={GetDateTimeLocal()}
                            className="form-control form-control-xs"
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <div className="form-group">
                        <Button
                            isReady={isReady}
                            size="sm"
                            icon="check"
                            label="Apply"
                            color="primary"
                        />
                    </div>
                </Col>
            </Row>
        </form>

    </div>)
}


const Listing = () => {
    const searchColumn = 'title'
    const [isLoading, setIsLoading] = useState(true)
    const [entities, setEntities] = useState([])
    const [totalEntities, setTotalEntities] = useState(0)
    const [currentOffset, setCurrentOffset] = useState(0)
    const [currentLimit, setCurrentLimit] = useState(UseLimit)
    const [currentOrder, setCurrentOrder] = useState(UseOrder)
    const [searchValue, setSearchValue] = useState("")
    const [bulkAction, setBulkAction] = useState()
    const [lastChange, setLastChange] = useState(Date.now())
    const [customFilters, setCustomFilters] = useState({})


    const fetchEntities = async () => {
        let filters = {
            limit    : currentLimit,
            offset   : currentOffset,
            sortBy   : "created_at",
            sortOrder: currentOrder,
            ...customFilters
        };

        if (searchValue.trim() !== "") {
            filters["findBy"] = searchColumn;
            filters["findTerm"] = searchValue;
        }

        const request = await UsePut("/logs/get",
            {data: filters}
        );

        setTotalEntities(request.total);
        return request?.entities?.length > 0 ?
            request.entities : [];
    };

    useEffect(() => {
        fetchEntities().then((entities) => {
            setEntities(entities);
            setIsLoading(false);
        });
    }, [currentOffset, currentLimit, searchValue, currentOrder, lastChange, customFilters]);



    const handleDelete = async (selected) => {
        if (selected.length === 0) {
            UseMessage("error", "Please choose some items")
        } else {

            await UseDelete("/logs/delete",
                {
                    data     : {idx: selected},
                    onSuccess: (response) => {
                        setLastChange(Date.now());
                    },
                    onError  : (AxiosError) => {
                        if (AxiosError?.response?.data?.message) {
                            UseMessage("error", AxiosError.response.data.message)
                        }
                    }
                }
            );


        }
    };


    const setFilters = (filters) => {
        setCustomFilters(filters)
    }


    const ListingOptions = {
        entities      : entities,
        isLoading     : isLoading,
        currentPage   : Math.ceil(currentOffset / currentLimit) + 1,
        totalEntities : totalEntities,
        currentLimit  : currentLimit,
        currentOrder  : currentOrder,
        searchColumn  : searchColumn,
        template      : "table",
        onSearch      : (value) => {
            setCurrentOffset(0);
            setSearchValue(value);
        },
        onCleanSearch : () => {
            setSearchValue("");
        },
        onChangePage  : (page) => {
            setCurrentOffset(currentLimit * (page - 1));
        },
        onChangeLimit : (ev) => {
            UseLimit(setCurrentLimit, ev.target.text);
        },
        onChangeOrder : (ev) => {
            UseOrder(setCurrentOrder, ev.target.text);
        },
        onChangeAction: (action) => {
            setBulkAction(action);
        },
        onClickApply  : (selected) => {
            if (typeof bulkAction == "undefined") {
                UseMessage("error", "Please choose an action")
            } else {
                bulkAction["action"](selected);
            }
        },
        columns       : [
            {
                label: "Created at", size: 15, prop: "created_at", output: (entity) => {
                    return UtcDateTimeToDateTime(entity?.created_at);
                }
            },
            {
                label: "Type", size: 15, prop: "type"
            },
            {
                label: "Category", size: 15, prop: "category"
            },
            {
                label: "Component", size: 15, prop: "component", output: (entity) => {
                    return entity?.component?.slug;
                }
            },
            {
                label: "Title", prop: "title", size: 25, output: (entity) => {
                    return <Link to={`/logs/${entity?._id?.$oid}`}>
                        <strong>{entity.title}</strong>
                    </Link>;
                }
            }
        ],
        filters       : <Filters isReady={!isLoading} onApplyFilter={setFilters}/>,
        actions       : [
            {value: "delete", label: "Delete", action: (selected) => handleDelete(selected)}
        ],
        rowActions    : [
            {
                path : `/logs/:id`,
                label: "Edit Entity",
                icon : "edit"
            },
        ],
    };


    return (
        <>
            <ListingTable {...ListingOptions} />
        </>
    )
}

export default Listing;